import React from 'react';
import CustomItemModal from "./CustomItemModal";

const CreateCustomBoothItemModal = ({ open, onClose, onSave }) => {
  return (
    <CustomItemModal open={open} onClose={onClose} onSave={onSave} />
  );
};

export default CreateCustomBoothItemModal;
